/**
 * Usage: image alt text = alt#variantname_variantvalue
 * Example: alt#color_red
 */

document.addEventListener("DOMContentLoaded", function () {
  const formInputs = document.querySelectorAll(".product-form__input input");
  const mediaItems = document.querySelectorAll(
    ".product__media-item[data-variant-name], .thumbnail-list__item[data-variant-name]"
  );
  if (mediaItems.length > 0) {
    // If there are variant images with data-variant-name attributes
    formInputs.forEach((input) => {
      input.addEventListener("click", (e) => {
        const variantType = input.getAttribute("name").toLowerCase();
        const variantValue = input.getAttribute("value").toLowerCase();
        mediaItems.forEach((item) => {
          if (
            item.getAttribute("data-variant-name").toLowerCase() === variantType
          ) {
            if (
              item.getAttribute("data-variant-value").toLowerCase() ===
              variantValue
            ) {
              item.classList.remove("hidden");
            } else {
              item.classList.add("hidden");
            }
          }
        });
      });
    });
  }
});
